import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon47: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 16.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 16 20" width={width} height={height} {...props}>
      <Path
        d="M8.0003 0C9.3804 0 10.5003 1.12 10.5003 2.5V3.55899C12.5814 4.55299 14.0001 6.76299 14.0001 9.23599V12.334L15.7001 14.6C16.4413 15.589 15.736 17 14.5001 17L11.4647 17.001C11.2217 18.697 9.7633 20 8.0003 20C6.2372 20 4.77885 18.697 4.53584 17.001L1.50007 17C0.264178 17 -0.441152 15.589 0.300068 14.6L2.00007 12.334V9C2.00007 6.565 3.44177 4.49001 5.49975 3.54501L5.50027 2.5C5.50027 1.12 6.6201 0 8.0003 0ZM10.4502 17H5.55036C5.78214 18.141 6.7908 19 8.0003 19C9.2097 19 10.2184 18.141 10.4502 17ZM8.4926 4.02301C5.53067 3.74001 3.00007 6.055 3.00007 9V12.5C3.00007 12.609 2.96498 12.714 2.90007 12.8L1.10014 15.2C0.853098 15.53 1.08827 16 1.50007 16H14.5001C14.9119 16 15.147 15.53 14.9 15.2L13.1001 12.8C13.0352 12.714 13.0001 12.609 13.0001 12.5V9.23599C13.0001 6.56399 11.0406 4.26601 8.4926 4.02301ZM8.0003 1C7.1724 1 6.5003 1.672 6.5003 2.5L6.5 3.189C7.1602 3.019 7.8632 2.95902 8.5876 3.02802C8.9 3.05702 9.2048 3.11301 9.5003 3.19101V2.5C9.5003 1.672 8.8281 1 8.0003 1Z"
        fill="#FFD147"
      />
    </Icon>
  )
}
